export default "__VITE_ASSET__38507b07__"